__turbopack_context__.v({
  "goBack": "SettingsDetail-module__P4hDuq__goBack",
  "root": "SettingsDetail-module__P4hDuq__root",
});
